module.exports = __webpack_public_path__ + "img/seven7Red.376cef2b.jpg";